import animAnalyze from '../../../assets/homepageAnimations/analyze.svg';
import animCreate from '../../../assets/homepageAnimations/create.svg';
import animShare from '../../../assets/homepageAnimations/share.svg';

export default [
	{
		title: 'Create and custormize your website in minutes!',
		content:
			'Start a free website using Webbler with mobile-responsive templates. Highlight important content like bio, socials, links, playlists, and more!',
		animation: animCreate,
	},
	{
		title: 'Share it anywhere you like!',
		content:
			'Once your website is created. Simply copy and paste to Instagram, TikTok, Patreon, or anywhere with a social bio. Let worlds know who you are!',
		animation: animShare,
	},
	{
		title: 'Analyze your audience!',
		content:
			'Track your engagement over time and learn what’s converting your audience. Easily track which link get the most clicks!',
		animation: animAnalyze,
	},
];
